import { Box, Button } from "@material-ui/core";
import { ViewOnlySelector } from "../../../components/ViewOnlySelector";
import { ViewOnlyTextField } from "../../../components/ViewOnlyTextField";
import { useInstalledAppDeleteDialogs } from "../hooks/useInstalledAppDeleteDialogs";
import { useProductOption } from "../hooks/useProductOption";
import { useAppTypeOption } from "../hooks/useAppTypeOption";

type ApiDetailsProps = {
  name: string;
  description: string;
  productId: string;
  type: string;
  uri: string;
  isLoading?: boolean;
};

/**
 * 連携アプリの詳細を表示するコンポーネントです。<br />
 * *各項目は入力不可
 */
export const InstalledAppDetails: React.FC<ApiDetailsProps> = ({
  name,
  description,
  productId,
  type,
  uri,
  isLoading = false,
}) => {
  const { openDialog, InstalledAppDeleteDialog } =
    useInstalledAppDeleteDialogs();
  const { productOptions } = useProductOption();
  const { appTypeOptions } = useAppTypeOption();

  return (
    <Box mt={4}>
      <Box mb={2} display="flex" justifyContent="flex-end">
        <Button
          disableRipple
          color="secondary"
          variant="contained"
          disabled={isLoading}
          onClick={openDialog}
        >
          連携解除
        </Button>
      </Box>
      <Box>
        <ViewOnlyTextField label="名前" value={name} />
        <ViewOnlyTextField label="概要" value={description} />

        <ViewOnlySelector
          title="連携する製品"
          value={productId}
          options={productOptions}
        />
        <ViewOnlySelector
          title="アプリの種類"
          value={type}
          options={appTypeOptions}
        />

        <ViewOnlyTextField label="ホームページURL" value={uri} />
      </Box>

      {InstalledAppDeleteDialog}
    </Box>
  );
};
